import type { AirlineIconProps, AirlineIconSize } from './AirlineIcon.types'
import cn from 'classnames'
import * as React from 'react'
import * as airlineIconGlyphs from '../../airline-glyphs'
import styles from './AirlineIcon.module.css'

export { airlineCodesMap, type AirlineIconGlyph } from '@sunwebgroup/uds-airline-icons/airline-codes-map'

export const allAirlineIconGlyphNames = Object.keys(airlineIconGlyphs)

const sizeClassMap: Record<AirlineIconSize, string> = {
  'xs': styles.xs,
  'sm': styles.sm,
  'md': styles.md,
  'lg': styles.lg,
  'xl': styles.xl,
  '2xl': styles.size2xl,
}

export function AirlineIcon({ className, glyph, size = 'sm', ...attrs }: AirlineIconProps) {
  const GlyphComponent = airlineIconGlyphs[glyph]

  if (GlyphComponent === undefined) {
    console.error(`Icon: No icon found for glyph "${glyph}"`)
    return null
  }

  return (
    <span className={cn(styles.airlineIcon, sizeClassMap[size], className)}>
      <GlyphComponent {...attrs} />
    </span>
  )
}

AirlineIcon.displayName = 'AirlineIcon'
